var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-time-picker',{staticStyle:{"width":"40vw"},attrs:{"is-range":"","editable":false,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","placeholder":"选择时间范围","format":"HH:mm","value-format":"HH:mm"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }